import React from "react";
import { FileText } from "lucide-react";
import "./RestaurantsCard.css";

const christmasPdf = "/assets/menu/christmas-packages.pdf";
const winterPdf = "/assets/menu/winter-packages.pdf";

const cards = [
  {
    id: 1,
    title: "Christmas Lunch",
    image: "/assets/restaurants-5.jpg",
    description:
      "Gather with loved ones this Christmas for a traditional lunch filled with seasonal flavours, laughter, and holiday cheer.",
    pdf: "/assets/menu/christmas-lunch.pdf",
  },
  {
    id: 2,
    title: "New Years Eve Gala Dinner",
    image: "/assets/restaurants-4.jpg",
    description:
      "Join us for a dazzling New Year’s Eve Gala Dinner — where laughter, music, and celebration welcome the year ahead!",
    pdf: "/assets/menu/new-years-gala-dinner.pdf",
  },
  {
    id: 3,
    title: "New Years Day Brunch",
    image: "/assets/restaurants-2.jpg",
    description:
      "Welcome 2026 by the Sea — Celebrate the first day of the year with a relaxing seaside brunch at The Majestic Hotel, Eastbourne. Savour a tempting buffet of breakfast classics and seasonal delights — the perfect way to begin 2026. 10am – 2pm | £22 per person.",
    pdf: "/assets/menu/new-years-day-brunch.pdf",
  },
  {
    id: 4,
    title: "Festive Afternoon Tea",
    image: "/assets/restaurants-1.jpg",
    description:
      "Soak up the sparkling sea views this festive season with our delightful Festive Afternoon Tea at The Majestic Hotel, Eastbourne. Enjoy seasonal sandwiches, warm scones, and indulgent sweet treats — all served with a touch of seaside magic. Just £22 per person.",
    pdf: "/assets/menu/festive-afternoon-tea.pdf",
  },
  {
    id: 5,
    title: "Christmas Parties",
    image: "/assets/restaurants-6.jpg",
    description:
      "Celebrate the most magical time of the year in true Majestic style! Whether it’s a festive gathering with colleagues or a joyful evening with friends, our Christmas parties promise sparkle, sophistication, and seasonal cheer.",
    pdf: "/assets/menu/christmas-parties.pdf",
  },
  {
    id: 6,
    title: "Boxing Day",
    image: "/assets/restaurants-3.jpg",
    description:
      "Indulge in a Boxing Day tradition of buttery mince pies and perfectly brewed tea, served with a touch of festive elegance!",
    pdf: "/assets/menu/boxing-day.pdf",
  },
];

export default function RestaurantsCards() {
  return (
    <section className="rc-section">
      {/* ---- Top Buttons ---- */}
      <div className="rc-top">
        <a
          className="rc-btn"
          href={christmasPdf}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FileText size={18} className="rc-icon" /> VIEW OUR CHRISTMAS PACKAGES
        </a>

        <a
          className="rc-btn"
          href={winterPdf}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FileText size={18} className="rc-icon" /> VIEW OUR WINTER PACKAGES
        </a>
      </div>

      {/* ---- Cards Grid ---- */}
      <div className="rc-grid">
        {cards.map((c) => (
          <article className="rc-card" key={c.id}>
            <img src={c.image} alt={c.title} className="rc-image" loading="lazy" />
            <h3 className="rc-title">{c.title}</h3>
            <p className="rc-desc">{c.description}</p>

            <div className="rc-readmore">
              <a
                href={c.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="rc-readmore-link"
              >
                View Menu <span className="rc-arrow">→</span>
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
